import { ApiBase } from './ApiBase';
class MetaPartnerApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getMetaConfiguration = () => {
            return this.get('/creator-integrations/meta-partner/configuration');
        };
        this.deleteMetaConfiguration = () => {
            return this.delete('/creator-integrations/meta-partner/configuration');
        };
        this.updateMetaStatus = (payload) => {
            return this.put('/creator-integrations/meta-partner/configuration/status', payload);
        };
        this.getMetaCatalogs = () => {
            return this.get('/creator-integrations/meta-partner/configuration/meta-catalogs');
        };
        this.updateMetaCatalog = (params) => {
            return this.put(`/creator-integrations/meta-partner/configuration/meta-catalogs/${params.metaProductCatalogId}`);
        };
    }
}
export const MetaPartnerApiClient = new MetaPartnerApiClientModel();
